export default __webpack_public_path__ + "static/docs@2x-e9b16fc7304227ef63103c00afadbe43.png";